import React from "react";
import { Container, ImgBox1, TextBox1, Wrapper } from "./style";
import { useMediaQuery } from "react-responsive";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectLanguage } from "redux/reducers/languageReducer";
const Com4 = () => {
  const isPc = useMediaQuery({
    query: "(min-width:900px)",
  });
  const { t } = useTranslation("sketchWallet");
  const language = useSelector(selectLanguage);
  return (
    <Wrapper>
      {isPc ? (
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/943908edSketchWallet_5.svg"
          alt="backgroundImg"
        />
      ) : (
        <img
          loading="lazy"
          src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/71eda312SketchWallet_5.svg"
          alt="backgroundImg"
        />
      )}

      <Container>
        <TextBox1>
          <div>{t("4-1")}</div>
          <div>
            <span>{t("4-2")}</span>
            <span>{t("4-2-1")}</span>
            <br />
            <span>{t("4-3")}</span>
            <span>{t("4-4")}</span>
          </div>

          <div>
            {language === "en" ? (
              <a
                href="https://play.google.com/store/apps/details?id=com.sketch.wallet"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/4f46f708Home_12.svg"
                  alt="googlePlayStore"
                />
              </a>
            ) : (
              <a
                href="https://play.google.com/store/apps/details?id=com.sketch.wallet"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/884be2c9Home_1.svg"
                  alt="googlePlayStore"
                />
              </a>
            )}

            {language === "en" ? (
              <a
                href="https://apps.apple.com/kr/app/%EC%8A%A4%EC%BC%80%EC%B9%98%EC%9B%94%EB%A0%9B-sketch-wallet-bitsafe/id1597866658"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/959c55f4Home_13.svg"
                  alt="applePlayStore"
                />
              </a>
            ) : (
              <a
                href="https://apps.apple.com/kr/app/%EC%8A%A4%EC%BC%80%EC%B9%98%EC%9B%94%EB%A0%9B-sketch-wallet-bitsafe/id1597866658"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  loading="lazy"
                  src="https://sketch-htm.s3.ap-northeast-2.amazonaws.com/file/d57a6aa0Home_2.svg"
                  alt="applePlayStore"
                />
              </a>
            )}
          </div>
        </TextBox1>
        <ImgBox1 loading="lazy">
          <img loading="lazy" src="/assets/img/SketchWallet_1.svg" alt="phoneImg" />
        </ImgBox1>
      </Container>
    </Wrapper>
  );
};

export default Com4;
